import React from "react";
import { IconType } from "react-icons";

interface DescriptionCardsProps {
  id: number;
  title: string;
  description: string;
  icon: IconType;
}

const DescriptionCards = ({
  description
}: {
  description: DescriptionCardsProps;
}) => {
  return (
    <section className="h-fit py-4 flex gap-4 relative">
      <div className="-mt-4 ">
        {description.icon && (
          <description.icon size={24} className="!text-text w-10 lg:w-12 h-10 lg:h-12 p-2 border-2 shadow-md shadow-primary border-text rounded-full" />
        )}
      </div>

      <div className="space-y-2">
        <p className="text-2xl lg:text-3xl">{description.title}</p>
        <p>{description.description}</p>
      </div>
    </section>
  );
};

export default DescriptionCards;
